import constants from 'common/constants';
import axios from 'utils/bsac-api.js';

const state = {
  shopList: null,
};

const getters = {
  /**
   *
   * @param {*} state
   * @returns
   */
  shopList: (state) => state.shopList,
  /**
   *
   * @param {*} state
   * @returns
   */
  shopListByRegion: (state) => {
    let shopList = state.shopList;

    // sort_orderの照準で並び替え
    // https://www.webprofessional.jp/sort-an-array-of-objects-in-javascript/
    // console.log('sort[before]:' + JSON.stringify(state.shopList));
    shopList.sort((a, b) => a.sort_order - b.sort_order);
    // console.log('sort[after]:' + JSON.stringify(state.shopList));

    // regionのみの配列を作成
    let regionNames = [];
    shopList.forEach((shop) => {
      regionNames.push(shop.region);
    });
    //console.log('regionNames duplicate[before]:' + regionNames);
    // 重複を除去
    // https://qiita.com/cocottejs/items/7afe6d5f27ee7c36c61f
    regionNames = regionNames.filter((x, i, self) => self.indexOf(x) === i);
    //console.log('regionNames duplicate[after]:' + regionNames);

    // regionとprefectureの配列を作成
    let regionPrefectureNames = [];
    shopList.forEach((shop) => {
      regionPrefectureNames.push(shop.region + '::' + shop.prefecture);
    });
    //console.log('regionPrefectureNames duplicate[before]:' + prefectureNames);
    // 重複を除去
    regionPrefectureNames = regionPrefectureNames.filter((x, i, self) => self.indexOf(x) === i);
    //console.log('regionPrefectureNames duplicate[after]:' + regionPrefectureNames);

    let elements = [];
    regionNames.forEach((regionName) => {
      let categories = [];
      regionPrefectureNames.forEach((regionPrefecture) => {
        let category = {};
        let regionPrefectureAry = regionPrefecture.split('::');
        if (regionPrefectureAry.length === 2) {
          if (regionPrefectureAry[0] === regionName) {
            //console.log('regionPrefectureAry:' + regionPrefectureAry);

            let items = [];
            shopList
              .filter(function (shop) {
                return (
                  shop.region === regionPrefectureAry[0] &&
                  shop.prefecture === regionPrefectureAry[1]
                );
              })
              .forEach((shop) => {
                let item = {};
                item.key = shop.name;
                let value = '〒 ' + shop.postcode;
                if (shop.address1st) value += ' ' + shop.address1st;
                if (shop.address2nd) value += ' ' + shop.address2nd;
                value += '</br>';
                if (shop.tel) value += 'TEL: <a href="tel:' + shop.tel + '">' + shop.tel + '</a>';
                //if (shop.fax) value += ' / FAX: ' + shop.fax;
                value += '</br>';
                if (shop.hpurl)
                  value += '<a href="URL" target="_blank">URL</a>'.replace(/URL/g, shop.hpurl);
                item.value = value;
                items.push(item);
              });

            category.name = regionPrefectureAry[1];
            category.items = items;
            categories.push(category);
          }
        }
      });

      let element = {};
      element.title = regionName + 'エリア';
      element.categories = categories;
      //console.log('region: ' + JSON.stringify(element));

      elements.push(element);
    });

    return elements;
  },
  /**
   * 都道府県別ショップリストを取得する
   * @param {*} state
   * @returns
   */
  shopListByPrefecture: (state) => {
    // console.log(JSON.stringify(state.shopList));
    if (!state.shopList) return null;

    let shopsByPrefecture = JSON.parse(JSON.stringify(constants.SHOPS_BY_PREFECTURE));
    state.shopList.forEach(function (shop) {
      // console.log(`name:${shop.name} prefecture:${shop.prefecture}`);
      let matched = false;
      shopsByPrefecture.forEach(function (prefecture) {
        if (shop.prefecture === prefecture.name) {
          // console.log(`prefecture: ${prefecture.name}`);
          prefecture.shops.push(shop);
          matched = true;
        }
      });
      // 都道府県がマッチしない場合は海外にセットする
      if (!matched) shopsByPrefecture[47].shops.push(shop);
    });
    shopsByPrefecture[48].shops.push({
      id: -1,
      name: 'その他'
    });
    // console.log(JSON.stringify(shopsByPrefecture));
    // ショップが1つ以上セットされている都道府県のみ返す
    return shopsByPrefecture.filter(function (prefecture) {
      return prefecture.shops.length > 0;
    });
  },
  // shopNames: (state) => {
  //   let names = [];

  //   state.shopList.forEach((shop) => {
  //     names.push(shop.name);
  //   });

  //   // 重複を除去
  //   // https://qiita.com/cocottejs/items/7afe6d5f27ee7c36c61f
  //   names = names.filter((x, i, self) => self.indexOf(x) === i);

  //   return names;
  // },
};

const mutations = {
  /**
   * ストアを初期化する
   * @param {*} state
   */
  reset(state) {
    state.shopList = [];
  },
  /**
   * ダイブセンターをセットする
   * @param {*} state
   * @param {*} shops
   */
  setShopList(state, shops) {
    state.shopList = shops;
    //console.log(JSON.stringify(state.shopList));
  },
};

const actions = {
  /**
   * APIを呼び出しeラーニング申込用ダイブセンターを取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getShopsForELearningApplication({ commit }) {
    return axios
      .get(process.env.FRONT_URL + '/elearning/dive_centers')
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setShopList', response.data.data);
        return {
          success: true,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
        };
      });
  },
  /**
   * APIを呼び出しコース申込用ダイブセンターを取得する
   * @param {*} param0
   * @param {*} state
   * @returns
   */
  getShopsForCourseApplication({ commit }) {
    return axios
      .get(process.env.FRONT_URL + '/form/dive_centers')
      .then((response) => {
        // console.debug('response:' + JSON.stringify(response));
        commit('setShopList', response.data.data);
        return {
          success: true,
        };
      })
      .catch((error) => {
        console.error(error.response);
        return {
          success: false,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
